module.exports = __webpack_public_path__ + "img/Youtube_hover.d6ab0603.svg";